import { differenceInYears, differenceInMonths, differenceInWeeks, differenceInDays, differenceInHours, differenceInMinutes, } from 'date-fns';
export const getTimeSinceComment = (fromDate) => {
    const now = new Date();
    const years = differenceInYears(now, fromDate);
    const months = differenceInMonths(now, fromDate);
    const weeks = differenceInWeeks(now, fromDate);
    const days = differenceInDays(now, fromDate);
    const hours = differenceInHours(now, fromDate);
    const minutes = differenceInMinutes(now, fromDate);
    let value = years || months || weeks || days || hours || minutes;
    let type = '';
    if (years)
        type = 'years';
    else if (months)
        type = 'month';
    else if (weeks)
        type = 'week';
    else if (days)
        type = 'day';
    else if (hours)
        type = 'hour';
    else if (minutes)
        type = 'minute';
    else
        type = 'second';
    const isPlural = value !== 1 ? true : false;
    return `${value} ${type}${isPlural ? 's' : ''} ago`;
};
//# sourceMappingURL=getTimeSinceComment.js.map